import Vue from "vue";
import Vuex from "vuex";
import accounts from "./modules/accounts/";
import admin from "./modules/admin/";
import auth from "./modules/auth/";
import customer from "./modules/customer/";
import deposit from "./modules/deposit/";
import foreignExchange from "./modules/foreignExchange/";
import loans from "./modules/loans/";
import transfer from "./modules/transfer/";
import payment from "./modules/payment/";
import native from "./modules/native/";
import common from "./modules/common/";
import { getField, updateField } from "vuex-map-fields";
import router from "../router";
// import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

const getSessionState = () => {
  return {
    isLogin: false,
    siteCode: "" /** vuejs에서 넘겨주는 접속사이트 코트 **/,
    natCode: "" /** vuejs에서 넘겨주는 언어 코드 **/,
    noticePopup: [] /**공지사항 팝업관련 데이터 **/,
    mOtpPopup: [] /**mOTP광고 팝업관련 데이터 **/,
    operGroupCd: "",
    cmgrCd: "",
    tranBrncd: "",
    userInfo: {
      lginWay: "" /** 로그인 방법 01:ID/PW, 08:OTP**/,
      lginInfo: "" /** 로그인 정보 - sessionInfo 항목에 셋팅할 값.. **/,
      operGroupCd: "" /** 운영그룹코드        **/,
      brnCd: "" /** 부점코드            **/,
      mainPrcssYn: "" /** 본처리여부          **/,
      acctgInptBookRepsntYn: "" /** 회계입력부 표시여부 **/,
      bzwkGroupCd: "" /** 업무그룹코드 **/,
      outptFmID: "" /** 출력폼ID **/,
      outptFmCnt: "" /** 출력폼갯수 **/,
      outptSpareItem1: "" /** 출력예비항목1 **/,
      outptSpareItem2: "" /** 출력예비항목2 **/,
      outptSpareItem3: "" /** 출력예비항목3 **/,
      ppsnCoprDstcd: "1" /** 개인법인구분코드 **/,
      userIdnfr: "" /** 사용자식별자 **/,
      userName: "" /** 사용자명 **/,
      subUserIdnfr: "" /** SUB사용자식별자 **/,
      subUserName: "" /** SUB사용자명 **/,
      sbidDstcd: "" /** SUBID구분코드 **/,
      cno: "" /** 고객번호 **/,
      bzoprYmd: "" /** 당영업일자 **/,
      bfBzoprYmd: "" /** 전영업일자 **/,
      nxbizYmd: "" /** 익영업일자 **/,
      bzoprStartTtm: "" /** 영업시작시간 **/,
      bzoprEndTtm: "" /** 영업종료시간 **/,
      baseCncycd: "" /** 기준통화코드 **/,
      otpUniqIdnfiNo: "" /** 보안장치고유식별번호 **/,
      otpPasswordUseYn: "" /** 로그인OTP사용여부 **/,
      scurtyDeviVndrDstcd: "" /** 보안장치벤더구분코드 **/,
      userPwdRegiYn: "" /** 사용자비밀번호등록여부 **/,
      drwotAcnRegiDstcd: "" /** 출금계좌등록구분코드 **/,
      lastLginYms: "" /** 최종로그인일시 **/,
      mblSvcUtznCnsntYn: "" /** 모바일서비스이용동의여부 **/,
      mblSvcFrstJoinYmd: "" /** 모바일서비스최초가입년월일 **/,
      ppsnBrdt: "" /** 생년월일 **/,
      telno: "" /** 전화번호 **/,
      cphnNo: "" /** 휴대폰번호 **/,
      pushRecvCnsntYn: "" /** 푸쉬수신동의여부 **/,
      totalLineCnt: "" /** 그리드행갯수1 **/,
      dataGrid: new Array() /** 출금계좌목록그리드 **/,
      totalLineCnt2: "" /** 그리드행갯수2 **/,
      dataGrid2: new Array() /** 입금계좌목록그리드 **/,
      isPincode: "0" /**/,
    },
    serverInfo: {
      sysDateTime: "" /** 현지시간 **/,
    },
    menuOpen: false,
  };
};

/**
 * main 컴포넌트 찾기
 * @param {Array} children children 리스트
 */
const findSearchBox = children => {
  for (const comp of children) {
    if (comp.$vnode.tag !== undefined && comp.$vnode.tag.indexOf("-rootMain") > 0) {
      return comp;
    } else {
      let etc = findSearchBox(comp.$children);
      if (etc !== undefined) return etc;
    }
  }
};

export default new Vuex.Store({
  state: {
    lang: "ENG",
    siteCode: "",
    operGroupCd: "",
    noticePopup: [] /**공지사항 팝업관련 데이터 **/,
    mOtpPopup: [] /**mOTP광고 팝업관련 데이터 **/,
    error: {
      active: false,
      errCode: "",
      errType: "",
      errMsg: "",
      errMsgI18n: "",
    },
    loading: false, //로딩바
    pageLoading: false,
    sessionInfo: getSessionState(),
    menu: null, //전체메뉴
    menuByLogout: null, //로그인 필요없는 메뉴
    menuOpen: false,
    popupOpen: false,
    menuTitle: "", //페이지 타이틀
    appExitModalOpended: false, //앱종료 팝업
    needLoginModalOpended: false, //로그인 필요 알림 팝업
    needLoginPath: "",
    simpleLogin: {
      fidoid: "" /** 간편로그인 아이디 **/,
      bioType: "" /** 간편로그인 인증수단 - 마지막에 등록한 인증수단 (IDPW/PINCODE/FINGERPRINT) **/,
      isPincode: "0" /** 간편로그인 사용자의 pincode 등록여부 */,
      isFingerprint: "0" /** 간편로그인 사용자의 fingerprint 등록여부 */,
      selectedLoginType: "" /** 로그인 화면 표시 (IDPW/PINCODE/FINGERPRINT) **/,
      bizDscd: "",
      isLoginAction: false,
      siteCodeForSimpleLogin: "",
      selectFidoInfo: {
        /** 서버의 fido 정보 - 비로그인 */
        coprPpsnDstcd: "",
        cin: "",
        wWWBnkgLginID: "",
        pinFailNotms: "",
        pinStusDstcd: "",
        fngprRegiDstcd: "",
        smphMchtlUniqNo: "",
        smphMchtlDstcd: "",
        pgmVsnno: "",
        smphMdelName: "",
      },
      appFidoInfo: [],
    },
    history: [], //back history 저장용
    backgroundTime: "", //앱이 백그라운드로 전환한 시간
    foregroundTime: "", //앱이 포어그라운드로 전환한 시간
    autoLogout: false,
    isFirstUser: false,
    globalToday: "",
    appAuth: "",
    isMenuClick: false,
    addtlInfo: [], //부가정보
  },
  getters: {
    getField,
    //개인법인구분코드 가져오기
    getSessionCoprDstcd: state => {
      return state.sessionInfo.userInfo ? state.sessionInfo.userInfo.ppsnCoprDstcd : "";
    },
    //개인
    isPersonalUser: state => {
      return state.sessionInfo.userInfo.ppsnCoprDstcd === "1";
    },
    //법인
    isCorporationUser: state => {
      return state.sessionInfo.userInfo.ppsnCoprDstcd === "2";
    },
    //법인(Master)
    isCorporationMasterUser: state => {
      return state.sessionInfo.userInfo.ppsnCoprDstcd === "2" && state.sessionInfo.userInfo.sbidDstcd === "1";
    },
    //법인(Sub)
    isCorporationSubUser: state => {
      return state.sessionInfo.userInfo.ppsnCoprDstcd === "2" && (state.sessionInfo.userInfo.sbidDstcd === "2" || state.sessionInfo.userInfo.sbidDstcd === "3");
    },
    //로그인되어있는 경우
    isLogin: state => {
      return state.sessionInfo.isLogin;
    },
    //사용자비밀번호등록여부
    isUserPwdRegiYn: state => {
      return state.sessionInfo.userInfo.userPwdRegiYn;
    },
    //사용자OTP구분 (01: otp, 02: mOtp, 03: AdvOtp)
    isUserOtpDstcd: state => {
      if (state.sessionInfo.userInfo.scurtyDeviVndrDstcd === "004") return "01";
      else if (state.sessionInfo.userInfo.scurtyDeviVndrDstcd === "701") return "02";
      else if (state.sessionInfo.userInfo.scurtyDeviVndrDstcd === "304") return "03";
      else return "";
    },
    //PINCODE등록여부
    isPincodeRegiYn: state => {
      return state.sessionInfo.userInfo.isPincode;
    },
    //생체정보등록필수고객여부
    isLvbdInfoRegiMandanCustYn: state => {
      return state.sessionInfo.userInfo.lvbdInfoRegiMandanCustYn === "1";
    },
    // 생체정보등록여부
    isLvbdInfoRegiYn: state => {
      return state.sessionInfo.userInfo.lvbdInfoRegiYn === "1";
    },
    GET_SERVERINFO_ALL: state => {
      return state.serverInfo;
    },
    // mOtpId를 가져옴.
    getMotpId: state => {
      if (state.sessionInfo.userInfo.ppsnCoprDstcd === "1") {
        return state.sessionInfo.userInfo.cno;
      } else if (state.sessionInfo.userInfo.ppsnCoprDstcd === "2") {
        let rtnUserIdnfr = "";
        if (state.sessionInfo.userInfo.sbidDstcd === "1") {
          rtnUserIdnfr = state.sessionInfo.userInfo.userIdnfr;
        } else if (state.sessionInfo.userInfo.sbidDstcd === "2" || state.sessionInfo.userInfo.sbidDstcd === "3") {
          rtnUserIdnfr = state.sessionInfo.userInfo.subUserIdnfr;
        }
        return rtnUserIdnfr + state.sessionInfo.userInfo.cno;
      }
    },
    getMenuByLogin: state => {
      //로그인 후 사용자별 메뉴 show/hide
      for (let m of state.menu) {
        let subShowCnt = 0;
        for (let submenu of m.children) {
          if (submenu.children) {
            let childShowCnt = 0;
            for (let child of submenu.children) {
              let isShowChild = true;
              let roles = router.resolve({ name: child.name }).resolved.meta.roles;
              if (roles == undefined) {
                child.isShow = isShowChild;
                childShowCnt++;
                continue;
              }
              //로그인 상태
              if (state.sessionInfo.isLogin) {
                if (state.sessionInfo.userInfo.ppsnCoprDstcd == "1") {
                  //개인
                  if (roles.includes("corp")) isShowChild = false;
                } else if (state.sessionInfo.userInfo.ppsnCoprDstcd == "2") {
                  if (state.sessionInfo.userInfo.sbidDstcd == "1") {
                    //기업 - 마스터
                    if (roles.includes("ppsn")) isShowChild = false;
                  } else if (state.sessionInfo.userInfo.sbidDstcd === "2" || state.sessionInfo.userInfo.sbidDstcd === "3") {
                    //기업 - 서브
                    if (roles.includes("ppsn") || roles.includes("master")) isShowChild = false;
                  }
                }
              }
              if (isShowChild) childShowCnt++;
              child.isShow = isShowChild;
            }
            if (childShowCnt != 0) subShowCnt++;
            submenu.isShow = childShowCnt != 0;
          } else {
            let isShowChild = true;
            let roles = router.resolve({ name: submenu.name }).resolved.meta.roles;
            if (roles == undefined) {
              subShowCnt++;
              submenu.isShow = isShowChild;
              continue;
            }
            //로그인 상태
            if (state.sessionInfo.isLogin) {
              if (state.sessionInfo.userInfo.ppsnCoprDstcd == "1") {
                //개인
                if (roles.includes("corp")) isShowChild = false;
              } else if (state.sessionInfo.userInfo.ppsnCoprDstcd == "2") {
                if (state.sessionInfo.userInfo.sbidDstcd == "1") {
                  //기업 - 마스터
                  if (roles.includes("ppsn")) isShowChild = false;
                } else if (state.sessionInfo.userInfo.sbidDstcd === "2" || state.sessionInfo.userInfo.sbidDstcd === "3") {
                  //기업 - 서브
                  if (roles.includes("ppsn") || roles.includes("master")) isShowChild = false;
                }
              }
            }
            if (isShowChild) subShowCnt++;
            submenu.isShow = isShowChild;
          }
        }
        m.isShow = subShowCnt != 0;
      }
      return state.menu;
    },
    getMenuByLogout: state => {
      state.menuByLogout = Object.freeze(_.cloneDeep(state.menu));
      //로그인 전 비로그인 메뉴 목록
      for (let m of state.menuByLogout) {
        let subShowCnt = 0;
        for (let submenu of m.children) {
          if (submenu.children) {
            let childShowCnt = 0;
            for (let child of submenu.children) {
              let isShowChild = true;
              let roles = router.resolve({ name: child.name }).resolved.meta.roles;
              if (roles == undefined) {
                child.isShow = isShowChild;
                childShowCnt++;
                continue;
              } else {
                isShowChild = false;
              }
            }
            if (childShowCnt != 0) subShowCnt++;
            submenu.isShow = childShowCnt != 0;
          } else {
            let isShowChild = true;
            let roles = router.resolve({ name: submenu.name }).resolved.meta.roles;
            if (roles === undefined) {
              subShowCnt++;
              submenu.isShow = isShowChild;
              continue;
            } else {
              isShowChild = false;
            }
          }
        }
        m.isShow = subShowCnt != 0;
      }
      return state.menuByLogout;
    },
  },

  mutations: {
    updateField,
    SET_SESSIONINFO_ALL: (state, payload) => {
      state.sessionInfo = payload;
      state.sessionInfo.isLogin = state.sessionInfo.userInfo.lginWay != "";
      state.operGroupCd = state.sessionInfo.operGroupCd;
    },
    SET_SESSIONINFO_EMPTY: state => {
      state.sessionInfo = getSessionState();
      state.addtlInfo = [];
    },
    setMenu(state, obj) {
      const fileName = obj.replace("og", "");
      const getMenu = () => import(`@/router/menu/${fileName}.json`);
      getMenu().then(data => {
        state.menu = data.default;
        sessionStorage.setItem("menu", JSON.stringify(data.default));
      });
    },
    setSiteCode(state, payload) {
      state.siteCode = payload.siteCode;
      state.operGroupCd =
        payload.siteCode == Vue.prototype.$config.SITECODE_OGHCM
          ? payload.isLogin
            ? state.sessionInfo.operGroupCd
            : Vue.prototype.$config.OPER_GROUP_CD_OGHCM
          : state.siteCode !== undefined
          ? Vue.prototype.$config[`OPER_GROUP_CD_${state.siteCode.toUpperCase()}`]
          : "";

      sessionStorage.setItem("siteCode", payload.siteCode);
      sessionStorage.setItem("operGroupCd", state.operGroupCd);
    },
    SET_SERVERINFO_ALL: (state, payload) => {
      //console.log(JSON.stringify(payload));
      state.serverInfo = payload;
    },
    setLoading(state, payload) {
      state.loading = payload;
    },
    setError(state, payload) {
      state.error = payload;
    },
    setIsPincodeRegiYn(state, payload) {
      state.sessionInfo.userInfo.isPincode = payload;
    },
    // 간편로그인 사용자에 대한 인증수단 정보를 업데이트 함. - 비로그인
    setFidoRegInfo: function (state, payload) {
      const fidoid = this.state.simpleLogin.fidoid;
      const s1 = this.state.simpleLogin.selectFidoInfo.smphMchtlUniqNo;
      const s2 = this.state.native.smphMchtlUniqNo;
      const sp = this.state.simpleLogin.selectFidoInfo.pinStusDstcd;
      const sf = this.state.simpleLogin.selectFidoInfo.fngprRegiDstcd;
      const arr = payload.Fidoinfo;

      this.state.simpleLogin.appFidoInfo = [];
      this.state.simpleLogin.appFidoInfo = payload.Fidoinfo;

      const fidoStatus = this._vm.$auth.getFidoStatusForLogin(fidoid, s1, s2, sp, sf, arr);
      // this._vm.$log.info("fidoStatus >>>> " + JSON.stringify(fidoStatus));
      this.state.simpleLogin.isPincode = " ";
      if (fidoStatus.isPincode === "1") {
        this.state.simpleLogin.isPincode = "1";
      } else {
        this.state.simpleLogin.isPincode = "0";
      }
      this.state.simpleLogin.isFingerprint = " ";
      if (fidoStatus.isFingerprint === "1") {
        this.state.simpleLogin.isFingerprint = "1";
      } else {
        this.state.simpleLogin.isFingerprint = "0";
      }
      // 마지막 로그인 수단 또는 마지막 FIDO 발급 수단 정보임.
      this.state.simpleLogin.selectedLoginType = this.state.simpleLogin.bioType;

      if (this.state.simpleLogin.bizDscd === "simpleLoginGoPage") {
        router.push({ name: "login" });
      }
      this.state.simpleLogin.bizDscd = "";
    },
    // 마지막에 접속한 간편로그인 인증수단 정보를 업데이트 함. - 비로그인
    setLastSimpleLogin: function (state, payload) {
      this.state.simpleLogin.fidoid = payload.userName;

      //login 화면에서만 setting
      //this.state.simpleLogin.bioType = payload.bioType;
      this.state.simpleLogin.bioType = "";

      // 마지막 로그인 수단 또는 마지막 FIDO 발급 수단 정보임.
      this.state.simpleLogin.selectedLoginType = payload.bioType;
    },
    // 앱권한 체크
    setAppAuth(state, payload) {
      this.state.appAuth = payload.result;
    },
    // simpleLogin 정보 수정
    setSimpleLogin(state, payload) {
      this._vm.$set(state.simpleLogin, payload.key, payload.value);
    },
  },
  actions: {
    ACT_SET_SESSIONINFO_ALL: function (context, payload) {
      context.commit("SET_SESSIONINFO_ALL", payload);
      // return new Promise((resolve, reject) => {
      // 	this._vm.$post(
      // 		"/account/inqury/WholAcnInq",
      // 		{},
      // 		function (response) {
      // 			context.dispatch("inquiryStore/actSetAccountList", response, { root: true });
      // 			resolve();
      // 		},
      // 		function () {
      // 			reject();
      // 		},
      // 	);
      // });
    },
    ACT_SET_SERVERINFO_ALL: (context, payload) => {
      context.commit("SET_SERVERINFO_ALL", payload);
    },
    ACT_GET_SERVERINFO_ALL: function (context) {
      return new Promise(resolve => {
        this._vm.$post(
          "/commonbiz/combiz/getSvrUtilInfo",
          {},
          function (response) {
            context.commit("SET_SERVERINFO_ALL", response);
            resolve(response);
          },
          () => {},
          null,
          null,
          false,
        );
      });
    },
    actAllStateReset({ dispatch }) {
      dispatch("common/actAllStateReset");
      dispatch("accounts/actAllStateReset");
      dispatch("admin/actAllStateReset");
      dispatch("auth/actAllStateReset");
      dispatch("customer/actAllStateReset");
      dispatch("deposit/actAllStateReset");
      dispatch("foreignExchange/actAllStateReset");
      dispatch("loans/actAllStateReset");
      dispatch("transfer/actAllStateReset");
      dispatch("payment/actAllStateReset");
    },
    ACT_EXEC_LOGOUT: function ({ commit, dispatch }) {
      return new Promise(resolve => {
        this._vm.$post(
          "/commonbiz/auth/actionLogout",
          {},
          function (response) {
            commit("SET_SESSIONINFO_EMPTY");
            dispatch("actAllStateReset");
            resolve(response);
          },
          function (response) {
            commit("SET_SESSIONINFO_EMPTY");
            dispatch("actAllStateReset");
            resolve(response);
          },
        );
      });
    },
    actSiteCode({ commit, dispatch, state }, payload) {
      let siteCode = String(payload).toLowerCase();
      const isSiteCodeChange = _.isEmpty(state.siteCode) || state.siteCode != siteCode;

      if (isSiteCodeChange) {
        dispatch("ACT_EXEC_LOGOUT", null, { root: true });
        // dispatch("actSetNews", [], { root: true });
      }
      commit("setSiteCode", { siteCode: siteCode, isLogin: this.getters["isLogin"] });
      commit("setMenu", siteCode);

      if (isSiteCodeChange) {
        router.push({ name: "main", params: { siteCode: siteCode, lang: state.lang } });
        let main = findSearchBox(router.app.$root.$children);
        if (main != undefined) {
          if (main.page == "2") {
            main.page = "1";
          }
        }
      }
    },
    actSetLoading({ commit }, payload) {
      commit("setLoading", payload);
    },
    actLoginSuccess: async function (context, payload) {
      context.commit("SET_SESSIONINFO_ALL", payload.response.SessionInfo);

      // 마지막 성공 로그인 정보 저장
      this._vm.$bridge.setSimpleLogin({
        userName: payload.response.mOtpId,
        bioType: payload.loginDscd,
        siteCode: this.state.siteCode,
      });

      if (payload.response.SessionInfo.isLogin) {
        //서비스 가입이 필요시
        if (payload.response.SessionInfo.userInfo.mblSvcUtznCnsntYn != "1") {
          //Sub 유저일 때는 권한이 없음
          if (payload.response.SessionInfo.userInfo.sbidDstcd == "2" || payload.response.SessionInfo.userInfo.sbidDstcd == "3") {
            //현재 기획이 결정되지 않아 서비스 동의 페이지로
            payload.router.push({ name: "serviceJoinStep1" });
          } else {
            // 일반, 기업 Master 의 경우 서비스 동의 페이지로 이동
            payload.router.push({ name: "serviceJoinStep1" });
          }
          return;
        }

        if (this.state.siteCode == Vue.prototype.$config.SITECODE_OGHCM) {
          this.state.native.depositEkyc = false;
          if (context.getters.isPersonalUser && payload.response.SessionInfo.userInfo.mchtlModfiYn == "1" && context.getters.isLvbdInfoRegiYn) {
            // 기기변경여부 1 && 생체정보등록여부 1 -> 생체정보검증 화면
            payload.router.push({ name: "ekycLogin" });
            return;
          } else if (payload.response.SessionInfo.userInfo.connAcitmDstic == "1A") {
            // 비대면으로 최초가입하였을때 임시 계정으로 생성 됨 (접속계정구분 1A:개인이면서  임시 조회용 ID)
            payload.router.push({ name: "serviceJoinStep3" });
            return;
          }
        }

        if (
          this.state.siteCode == Vue.prototype.$config.SITECODE_OGHCM &&
          "04|06".includes(payload.response.SessionInfo.userInfo.ovsesRcptDstcd) &&
          payload.response.SessionInfo.userInfo.mblSvcFrstJoinYmd == ""
        ) {
          payload.router.push({ name: "createMotpStep1" });
          return;
        }

        // 패스워드 변경대상임. 패스워드 변경화면으로 이동.
        if (context.getters.isUserPwdRegiYn == "1" || context.getters.isUserPwdRegiYn == "2") {
          //기업-서브사용자
          if (payload.response.SessionInfo.userInfo.sbidDstcd == "2" || payload.response.SessionInfo.userInfo.sbidDstcd == "3") {
            payload.router.push({ name: "errorPage", params: { type: Vue.prototype.$config.ERROR_FOR_MASTER } });
          } else {
            // createFido init
            context.commit("auth/createFido/resetState");

            // 간편인증번호가 이미 등록되어 있는지 확인.
            const result = await this._actions["auth/createFido/act014_createFido"][0]("PINCODE");
            //간편인증 등록 안되어있음=0/ 등록=1
            context.commit("setIsPincodeRegiYn", result.isPincode != "1" ? "0" : "1");

            //motp를 사용하는 국가 && 개인만
            if (`${Vue.prototype.$config.SITECODE_OGCBD}|${Vue.prototype.$config.SITECODE_OGHCM}`.includes(this.state.siteCode) && context.getters.isPersonalUser) {
              // native 내 mOTP정보 조회
              //await this._vm.$bridge.SSInfogetMotp_mOtpExstYN();
              await this._actions["auth/act003_checkMotpExstYN"][0]();

              if (context.getters.isUserOtpDstcd == "" || (context.getters.isUserOtpDstcd == "02" && context.getters["auth/getMotpExstYN"] == "N")) {
                //기기내 MOTP 없는 경우 MOTP 발급으로 이동
                payload.router.push({ name: "createMotpStep1", params: { nextRoutName: "changePasswordOnceStep1" } });
              } else {
                payload.router.push({ name: "changePasswordOnce" });
              }
            } else {
              payload.router.push({ name: "changePasswordOnce" });
            }
          }

          return;
        }
      }

      if (payload.route.query.redirect) {
        if (
          payload.route.query.redirect == "/tran/otrbnkTrsaccInfoInptReq/step1" &&
          this.state.siteCode == Vue.prototype.$config.SITECODE_OGHCM &&
          (context.getters.isUserOtpDstcd == "02" || context.getters.isUserOtpDstcd == "03")
        ) {
          payload.router.push({ name: "vtnOtrbnkTrsaccInfoInptReqStep1" });
        } else if (payload.route.query.redirect == "/tran/mmQR/mmQrPaymentStep1") {
          payload.router.push({ name: "main" , params: { redirect: payload.route.query.redirect }  });
        } else {
          payload.router.push({ path: payload.route.query.redirect });
        }
      } else {
        payload.router.push({ name: "main", params: { siteCode: context.state.siteCode, lang: context.state.lang } });
      }
    },
    actLoginCertn: async function (context, payload) {
      // Session 정보 set
      context.commit("SET_SESSIONINFO_ALL", payload.response.SessionInfo);

      // createFido init
      context.commit("auth/createFido/resetState");
      //this.$store._mutations["auth/createFido/resetState"][0]();

      // 간편인증번호가 이미 등록되어 있는지 확인.
      const result = await this._actions["auth/createFido/act014_createFido"][0]("PINCODE");

      if (this.state.simpleLogin.selectedLoginType == "PINCODE") {
        // PINCODE 선택 후 등록 신청 시 발행/재발행 진행
        if (result.isPincode != "1") {
          payload.router.push({ name: "createFidoPincodeStep1" });
        } else {
          payload.router.push({ name: "main" });
        }
      } else if (this.state.simpleLogin.selectedLoginType == "FINGERPRINT") {
        // 지문&FACEID 선택 후 등록 신청
        if (result.isPincode != "1") {
          // PINCODE 미등록 시 PINCODE 발급 프로세스로 이동
          this.state.auth.createFido.isFidoPopOpen = true;
          this.state.auth.createFido.fidoPopMessage = "MOTP-CERTN-21"; //MOTP-CERTN-21 : 먼저 간편인증번호 설정이 필요합니다.
          this.state.auth.createFido.fidoPopConfirm = () => {
            this.state.auth.createFido.isFidoPopOpen = false;
            payload.router.push({ name: "createFidoPincodeStep1" });
          };
          return;
        } else {
          if (result.isFingerprint != "1") {
            // 지문&FACEID 선택 후 등록 진행
            // 유효한 PINCODE가 존재하므로 발급으로 이동
            const param = {
              device: this.state.native.smphMchtlUniqNo,
              smphMdelName: this.state.native.smphMdelName,
              bioType: "PINCODE",
              bizDscd: "createFingerprint",
            };
            // act015_createFido -> brige -> act017_createFido
            this._actions["auth/createFido/act015_createFido"][0](param);
            return;
          } else {
            payload.router.push({ name: "main" });
          }
        }
      } else {
        // 위 조건 외 이동
        if (!_.isEmpty(payload.routeName)) {
          payload.router.push({ name: payload.routeName });
        } else {
          payload.router.push({ name: "main" });
        }
      }
    },
    /**
     * 간편로그인 fido정보를 조회함. - 비로그인 거래
     */
    actGetFidoInfo: function (context) {
      return new Promise(resolve => {
        if (context.state.simpleLogin.fidoid === "") {
          if (context.state.simpleLogin.bizDscd === "simpleLogin") {
            resolve("success");
          } else {
            router.push({ name: "login" });
          }
          return;
        }

        this._vm.$post("/auth/fido/certn/selectFidoInfo", { fidoid: context.state.simpleLogin.fidoid }, response => {
          this._vm.$set(context.state.simpleLogin, "selectFidoInfo", response.fidoInfo);
          context.dispatch("actCallBridge", "fidoRegInfo_bfLogin");
          resolve("success");
        });
      });
    },
    /**
     * bridge 호출
     */
    actCallBridge: function (context, payload) {
      switch (payload) {
        case "fidoRegInfo_bfLogin": // 기기에 등록된 fido 정보 전체를 요청. - 로그인 전
          this._vm.$bridge.fidoRegInfo_bfLogin();
          break;
        case "simpleLogin": // simple로그인 정보 조회
          // 비로그인 상태에서 간편로그인 정보 조회
          // 마지막에 등록한 인증수단이 null 인 경우 서버와 동기화 진행
          // simpleLogin -> simpleLogin_callback -> actGetFidoInfo -> fidoRegInfo_bfLogin
          // -> fidoRegInfo_callback_bfLogin -> setFidoRegInfo
          this.state.simpleLogin.bizDscd = "simpleLogin";
          this._vm.$bridge.simpleLogin({
            siteCode: context.state.siteCode,
          });
          break;
        case "simpleLoginGoPage": // simple로그인 정보 조회 후 페이지 이동
          this.state.simpleLogin.bizDscd = "simpleLoginGoPage";
          this._vm.$bridge.simpleLogin({
            siteCode: context.state.siteCode,
          });
          break;
      }
    },
    /**
     * 앱이 백그라운드에서 전환될 때 세션체크
     */
    actIsLoginSessionCheck: function () {
      return new Promise(resolve => {
        this._vm.$post("/commonbiz/combiz/isLoginSessionCheck", {}, response => {
          resolve(response);
        });
      });
    },
  },
  modules: {
    accounts,
    admin,
    auth,
    customer,
    deposit,
    foreignExchange,
    loans,
    transfer,
    payment,
    native,
    common,
  },
  // plugins: [createPersistedState({})],
});
